import { axios } from '$app-web/api/axios';
import { DataSourceOption } from '$app-web/types';

import { Endpoints } from '../constant';

type IResponse = Array<DataSourceOption>;

export async function fetchDataSourceOptions() {
    try {
        const { data, status } = await axios.get<IResponse>(Endpoints.DataSource.Options);
        if (status === 200) {
            return data;
        } else {
            return [];
        }
    } catch {
        return [];
    }
}
